import React, { useState } from "react";
import "./PaymentDetails.css";
import pay1 from "../assets/money.png";
import pay2 from "../assets/visa.png";
import pay3 from "../assets/paypal.png";
import pay4 from "../assets/apple-pay.png";
import NavUser from "../components/NavUser";

function PaymentDetails() {
  const [activeTab, setActiveTab] = useState("BankTransfer");

  return (
    <div className="payment-details-container">
      <NavUser />
      <h2 className="booking-title">Add Payment Details</h2>

      {/* Tabs Navigation */}
      <div className="payment-tabs">
        <button
          className={`payment-tab-btn ${activeTab === "BankTransfer" ? "active" : ""
            }`}
          onClick={() => setActiveTab("BankTransfer")}
        >
          Bank Transfer
        </button>
        <button
          className={`payment-tab-btn ${activeTab === "CreditCard" ? "active" : ""
            }`}
          onClick={() => setActiveTab("CreditCard")}
        >
          Credit/Debit Card
        </button>
      </div>

      {/* Bank Transfer Form */}
      {activeTab === "BankTransfer" && (
        <div className="bank-transfer-container">
          <form className="bank-transfer-form">
            <label className="form-label">
              Bank Name
              <input type="text" placeholder="Enter Bank Name" />
            </label>
            <label className="form-label">
              Account Number
              <input type="text" placeholder="Enter Account Number" />
            </label>
            <label className="form-label">
              Account Holder Name
              <input type="text" placeholder="Enter Account Holder Name" />
            </label>
            <label className="form-label">
              Bank Branch Location
              <input type="text" placeholder="Enter Branch Location" />
            </label>
            <button type="submit" className="save-bank-btn">
              Save Bank Details
            </button>
          </form>
        </div>
      )}

      {/* Credit/Debit Card Form */}
      {activeTab === "CreditCard" && (
        <div className="credit-card-container">
          <form className="credit-card-form">
            {/* Payment Method Selection */}
            <div className="payment-methods">
              <div className="payment-method-options">
                <div className="payment-box">
                  <img src={pay1} alt="Money" />
                </div>
                <div className="payment-box">
                  <img src={pay2} alt="Visa" />
                </div>
                <div className="payment-box">
                  <img src={pay3} alt="Paypal" />
                </div>
                <div className="payment-box">
                  <img src={pay4} alt="Apple Pay" />
                </div>
              </div>
            </div>

            {/* Card Details */}
            <label className="form-label">
              Card Number
              <input type="text" placeholder="XXXX-XXXX-XXXX-XXXX" />
            </label>
            <label className="form-label">
              Expiry Date
              <input type="text" placeholder="MM/YY" />
            </label>
            <label className="form-label">
              CVV Code
              <input type="text" placeholder="XXX" />
            </label>
            <label className="form-label">
              Cardholder Name
              <input type="text" placeholder="Enter Cardholder Name" />
            </label>

            {/* Billing Address */}
            <h3 className="billing-title">Billing Address (Optional)</h3>
            <label className="form-label">
              Country
              <input type="text" placeholder="Enter Country" />
            </label>
            <label className="form-label">
              Zip Code
              <input type="text" placeholder="Enter Zip Code" />
            </label>

            <button type="submit" className="save-card-btn">
              Save Card
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

export default PaymentDetails;
